var koKR = {
  locale: 'ko_KR',
  direction: 'ltr',
  date: {
    defaultFormat: {
      week: 'WW/YYYY',
      date: 'DD/MM/YYYY',
      month: 'MM/YYYY',
      year: 'YYYY',
      time: 'HH:mm:ss',
      dateTime: 'DD/MM/YYYY HH:mm:ss'
    },
    startDay: 0,
    shortMonthList: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    monthList: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    shortDayList: ['일', '월', '화', '수', '목', '금', '토'],
    dayList: ['일', '월', '화', '수', '목', '금', '토'],
    shortestDayList: ['일', '월', '화', '수', '목', '금', '토']
  },
  'dynamic-date': {
    day: '일',
    week: '주',
    month: '월',
    quarter: '분기',
    year: '년',
    before: '${value}${unit} 전'
  },
  'auto-complete.empty': '데이터 없음',
  'select.selected-count': '${count}개 항목 선택함',
  'date-time-picker.date': '날짜 선택',
  'image-view.zoom-out': '축소',
  'input.placeholder': '입력하세요',
  'empty.text': '데이터 없음',
  'date-picker.cancel': '취소',
  'date-picker.end': '종료 시간',
  'cascader.empty': '데이터 없음',
  'upload.drop': '파일을 여기로 끌어다 놓거나',
  'color.custom': '색상 사용자 지정',
  'cascader.titles': ['레벨 1', '레벨 2', '레벨 3', '레벨 4', '레벨 5', '레벨 6', '레벨 7', '레벨 8'],
  'date-comparison.error-target': '비교를 위한 종료 시간 선택',
  'transfer.empty': '데이터 없음',
  'select.search.placeholder': '입력하세요',
  'upload.click': '클릭하여 업로드',
  'date-time-picker.placeholder': '입력하세요',
  'pager.jump': '리디렉션',
  'tree-select.placeholder': '입력하세요',
  'dynamic-date.interval': '간격',
  'modal.cancel': '취소',
  'image-view.rotate': '회전',
  'tabs.more': '더 보기',
  'popover.ok': '확인',
  'transfer.placeholder': '입력하세요',
  'date.month': '월',
  'select.selected': '선택됨',
  'popover.cancel': '취소',
  'image-view.prev': '이전',
  'table.emptyText': '데이터 없음',
  'date-time-picker.ok': '확인',
  'table.filter.confirm': '확인',
  'tree-select.empty': '데이터 없음',
  'dynamic-date.fixed-date': '고정 날짜',
  'date-comparison.compare': '비교',
  'auto-complete.placeholder': '입력하세요',
  'time-picker.placeholder': '시간 선택',
  'date.month-first': false,
  'select.clear': '지우기',
  'date.year': '연도 ${year}',
  'date-comparison.yoy': '작년 이 기간',
  'image-view.zoom-to-origin': '원본',
  'schedule.title': '날짜/시간',
  'schedule.clear': '지우기',
  'date-time-picker.end': '종료 날짜 및 시간 선택',
  'dynamic-date.customize': '사용자 지정',
  'date-picker.apply': '적용',
  'schedule.selected': '선택한 시간',
  'dynamic-date.dynamic-date': '동적 날짜',
  'select.placeholder': '선택하세요',
  'schedule.separator': ',',
  'cascader.search': '입력하세요',
  'date-picker.invalid-range': '선택한 시간 범위가 선택 가능 범위를 초과합니다. 유효한 항목을 선택하세요.',
  'dynamic-date.date-preview': '날짜 미리 보기',
  'select.empty': '데이터 없음',
  'image-view.next': '다음',
  'date-time-picker.now': '지금',
  'date-time-picker.time': '시간 선택',
  'tree.empty': '데이터 없음',
  'pager.total': '기록 총 ${total}개',
  'image-view.zoom-in': '확대',
  'date-picker.placeholder': '날짜 선택',
  'textarea.placeholder': '입력하세요',
  'date.week': '주',
  'pager.size': '${count}개 기록/페이지',
  'modal.ok': '확인',
  'date-picker.start': '시작 시간',
  'table.filter.reset': '재설정',
  'image-view.zoom-to-fit': '맞춤',
  'pager.page.placeholder': '입력하세요',
  'select.select-all': '모두 선택',
  'list-viewer.empty': '데이터 없음',
  'date-comparison.compare-text': 'VS',
  'transfer.source': '소스 목록',
  'date-time-picker.start': '시작 날짜 및 시간 선택',
  'date-time-picker-panel.start': '시작일',
  'date-time-picker-panel.end': '종료일',
  'date-comparison.error-source': '비교를 위한 시작 시간 선택',
  'upload.error.overflow-count': '최대 파일 수를 초과했습니다',
  'date-comparison.placeholder': '시작 시간 - 종료 시간',
  'time-range-picker.placeholder': '시작 시간 - 종료 시간',
  'date-comparison.mom': '이전 기간과 비교',
  'transfer.target': '대상 목록',
  table: {
    selectionMenu: {
      selectCurrent: 'Select Current',
      selectAll: 'Select All',
      unselectCurrent: 'Unselect Current',
      unselectAll: 'Unselect All'
    }
  }
};
export default koKR;